import React from 'react';
import FiltersDoTp from './FiltersDoTp';
import FiltersEcp from './FiltersEcp';
import FiltersH2s from './FiltersH2s';
import FiltersHydro from './FiltersHydro';
import FiltersIndus from './FiltersIndus';
import FiltersMilieu from './FiltersMilieu';
import FiltersPluie from './FiltersPluie';
import FiltersPrMr from './FiltersPrMr';

interface Props {
  parentCallback: Function;
  allBc: any;
  module: string;
  allInseeCodesContract: any;
  option?: string;
}

const FiltersForms = (props: Props) => {
  if (props.module === 'do') {
    return (
      <FiltersDoTp
        module={props.module}
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
      />
    );
  } else if (props.module === 'pr') {
    return (
      <FiltersPrMr
        module={props.module}
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
      />
    );
  } else if (props.module === 'ecp') {
    return (
      <FiltersEcp
        module={props.module}
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
        allBc={props.allBc}
        allInseeCodesContract={props.allInseeCodesContract}
      />
    );
  } else if (props.module === 'h2s') {
    return (
      <FiltersH2s
        module={props.module}
        option={props.option}
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
      />
    );
  } else if (props.module === 'indus') {
    return (
      <FiltersIndus
        module={props.module}
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
        allBc={props.allBc}
        allInseeCodesContract={props.allInseeCodesContract}
      />
    );
  } else if (props.module === 'hydro') {
    return (
      <FiltersHydro
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
        allBc={props.allBc}
        allInseeCodesContract={props.allInseeCodesContract}
        module={props.module}
      />
    );
  } else if (props.module === 'milieu') {
    return (
      <FiltersMilieu
        module={props.module}
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
        option={props.option}
      />
    );
  } else if (props.module === 'pluie') {
    return (
      <FiltersPluie
        module={props.module}
        parentCallback={(d) => {
          props.parentCallback(d);
        }}
      />
    );
  } else {
    return null;
  }
};
export default FiltersForms;
